<div class="page-root">
  <div class="page-wide-column-body">
    <div class="page-column">
      <div class="title">
        <mat-icon>email</mat-icon>
      </div>

      <div class="title">
        <div class="typo-h1">{{ 'verification.title' | transloco }}</div>
      </div>

      <div class="body">
        <div class="body-text">
          {{ 'verification.subtitle.body' | transloco }}
          <br><br>
          {{ 'verification.subtitle.appendix' | transloco }}
        </div>

        <mat-form-field class="form-field" subscriptSizing="dynamic">
          <mat-label>{{ "form.label.verificationCode" | transloco }}</mat-label>
          <input [formControl]="verificationCode" matInput/>
        </mat-form-field>
      </div>

      @if (error) {
        <mat-error>
          {{ error }}
        </mat-error>
      }

      <div class="actions">
        <app-text-button (click)="verify()" [text]="'verification.button' | transloco" colorVariant="primary" trailingIcon="check_circle" type="rounded"></app-text-button>
      </div>
    </div>
  </div>
</div>
